import React, { useCallback, useState } from 'react';
import { Row, Col } from 'antd';
import PropTypes from 'prop-types';

import CustomModal from '../common/modals/CustomModal';
import OnTraccrTextInput from '../common/inputs/OnTraccrTextInput';
import OnTraccrButton from '../common/buttons/OnTraccrButton';
import colors from '../constants/Colors';

export default function ConfirmPasswordModal({
  visible,
  onClose,
  onConfirm,
}) {
  const [password, setPassword] = useState('');
  const [saving, setSaving] = useState(false);

  const resetAndClose = useCallback(() => {
    setPassword('');
    setSaving(false);
    onClose();
  }, [onClose]);

  const handleConfirm = useCallback(async () => {
    if (!password) return;
    setSaving(true);
    const ok = await onConfirm(password);
    setSaving(false);
    if (ok) onClose();
  }, [onClose, onConfirm, password]);

  return (
    <CustomModal
      title="Confirm changes"
      visible={visible}
      onCloseClicked={resetAndClose}
      maskColor={colors.MODAL_MASK_DARK}
      destroyOnClose
      afterClose={() => setPassword('')}
    >
      <div style={{ fontSize: 14, padding: '0 10px 10px' }}>
        Enter your password to confirm the changes.
      </div>
      <Row style={{ margin: '12px 10px 20px' }}>
        <OnTraccrTextInput
          password
          autoComplete="new-password"
          placeholder="Enter your password"
          onChange={(e) => setPassword(e?.target?.value ?? '')}
          value={password}
        />
      </Row>
      <Row justify="center" gutter={12} style={{ marginBottom: 10 }}>
        <Col>
          <OnTraccrButton
            type="cancel"
            title="Cancel"
            roundStyle
            onClick={resetAndClose}
            disabled={saving}
          />
        </Col>
        <Col>
          <OnTraccrButton
            title="Save"
            roundStyle
            loading={saving}
            disabled={!password || saving}
            onClick={handleConfirm}
          />
        </Col>
      </Row>
    </CustomModal>
  );
}

ConfirmPasswordModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

ConfirmPasswordModal.defaultProps = {
  visible: false,
  onClose: () => {},
  onConfirm: () => {},
};
